const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-HVYZ80CNHY';

type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: Gtag;
  }
}

/** True only for production deploys (build:prod / REACT_APP_ENVIRONMENT=production). */
export function isGoogleAnalyticsEnabled(): boolean {
  return (
    process.env.REACT_APP_ENVIRONMENT === 'production' &&
    Boolean(GA_MEASUREMENT_ID)
  );
}

function getGtag(): Gtag | undefined {
  return typeof window.gtag === 'function' ? window.gtag : undefined;
}

/** Load GA4 script and stub; page views are sent by GoogleAnalyticsRouteTracker. */
export function initGoogleAnalyticsProd(): void {
  if (!isGoogleAnalyticsEnabled()) return;

  const w = window;
  w.dataLayer = w.dataLayer || [];
  function gtag(...args: unknown[]) {
    w.dataLayer!.push(args);
  }
  w.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function trackGoogleAnalyticsPageView(
  path: string,
  title?: string
): void {
  const gtag = getGtag();
  if (!isGoogleAnalyticsEnabled() || !gtag) return;

  gtag('event', 'page_view', {
    page_path: path,
    page_title: title ?? document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}

export function trackGoogleAnalyticsEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>
): void {
  const gtag = getGtag();
  if (!isGoogleAnalyticsEnabled() || !gtag) return;
  gtag('event', eventName, params);
}
